import { Box, Container, Grid, GridItem, Image, Text } from "@chakra-ui/react";
import { landingPageConstants } from "common/landingPageConstants";
import WhyUsImgOne from "common/assets/img/Shield.png";
import WhyUsImgTwo from "common/assets/img/Workflow.png";
import WhyUsImgThree from "common/assets/img/Password.png";
import WhyUsImgFour from "common/assets/img/Graph.png";
import SubtitleIcon from "common/assets/img/subtitleIcon.png";

const whyUsData = [
  {
    icon: WhyUsImgOne,
    title: "Unified CRM & vassword vault",
    description:
      "Keep all your client data and credentials organized in one secure place.",
  },
  {
    icon: WhyUsImgTwo,
    title: "Task & workflow automation",
    description:
      "Streamline operations with intelligent task assignments and automation triggers.",
  },
  {
    icon: WhyUsImgThree,
    title: "Team password sharing",
    description:
      "Share login access confidently using permission-based controls and audit tracking.",
  },
  {
    icon: WhyUsImgFour,
    title: "Custom reports & dashboards",
    description:
      "Visualize performance metrics and make data-driven decisions with ease.",
  },
];

const WhyChooseUs = () => {
  return (
    <>
      <Container maxW="container.xl">
        <Box className="why-choose-us" id="whyUs">
          <Grid templateColumns={{ md: "repeat(5, 1fr)" }} gap={"60px"}>
            <GridItem colSpan={{base:5, md:5,lg:2}}>
              <Box className="sectionTitlebox leftside">
                <Text className="iconSubtitle">
                  {" "}
                  <Image
                    src={SubtitleIcon}
                    height={"16px"}
                    width={"16px"}
                    alt=""
                  />
                  {landingPageConstants.whyChooseUs}
                </Text>
                <Text className="sectionTitle">
                  {landingPageConstants.whyChooseUs}
                </Text>
                <Text className="sectionDesc">
                  {landingPageConstants.whyChooseUsDesc}
                </Text>
              </Box>
            </GridItem>
            <GridItem colSpan={{base:5, md:5,lg:3}}>
              <Grid templateColumns={{ md: "repeat(2, 1fr)" }} gap={"24px"}>
                {whyUsData.map((item, index) => (
                  <GridItem colSpan={1} key={index}>
                    <Box className="whyUsBox">
                      <Box className="whyUsImg">
                        <Image
                          src={item.icon}
                          height="24px"
                          width="24px"
                          objectFit="contain"
                          alt=""
                        />
                      </Box>
                      <Box className="whyUsContent">
                        <Text className="whyUsTitle">{item.title}</Text>
                        <Text className="whyUsDesc">{item.description}</Text>
                      </Box>
                    </Box>
                  </GridItem>
                ))}
              </Grid>
            </GridItem>
          </Grid>
        </Box>
      </Container>
    </>
  );
};
export default WhyChooseUs;
